import { create } from "zustand";
import { toast } from "sonner";
import { devtools } from "zustand/middleware";
import http from "@/lib/http";

const useBlogStore = create(
  devtools((set) => ({
    blogs: [],
    singleBlog: null,
    loading: false,
    error: null,
    pages: 0,
    total: 0,

    getAllBlogs: async ({ page = 1, limit = 10, search = "", category }) => {
      set({ loading: true, error: null });
      const params = {
        page,
        limit,
        ...(search ? { search } : {}),
        ...(category ? { category } : {}),
      };
      try {
        const { data } = await http.get("/public/blogs", { params });
        set({
          blogs: data?.blogs?.data || [],
          pages: data?.blogs?.pages || 0,
          total: data?.blogs?.total || 0,
          loading: false,
        });
        return data;
      } catch (error) {
        const errorMessage =
          error?.response?.data?.error || "Failed to fetch blogs";
        set({ error: errorMessage, loading: false });
        toast.error(errorMessage);
      }
    },

    getSingleBlog: async (id) => {
      set({ loading: true, error: null });
      try {
        const { data } = await http.get(`/public/blogs/${id}`);
        set({
          singleBlog: data?.blog || null,
          loading: false,
        });
        return data;
      } catch (error) {
        const errorMessage =
          error?.response?.data?.error || "Failed to fetch blog by ID";
        set({ error: errorMessage, loading: false });
        // toast.error(errorMessage);
      }
    },
  })),
);

export default useBlogStore;
